module.exports = __webpack_public_path__ + "static/media/reports.51217287.jpg";